'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'rainbow';
var width = 640;
var height = 512;
var aliases = [127752];
var unicode = 'f75b';
var svgPathData = ['M16 448c8.8 0 16-7.2 16-16l0-80C32 192.9 160.9 64 320 64S608 192.9 608 352l0 80c0 8.8 7.2 16 16 16l-120 0c8.8 0 16-7.2 16-16l0-84c0-112.7-91.3-204-204-204S112 235.3 112 348l0 84c0 8.8 7.2 16 16 16L16 448zm112 0c8.8 0 16-7.2 16-16l0-84c0-95 77-172 172-172s172 77 172 172l0 84c0 8.8 7.2 16 16 16l-104 0c8.8 0 16-7.2 16-16l0-80c0-53-43-96-96-96s-96 43-96 96l0 80c0 8.8 7.2 16 16 16l-112 0z', 'M320 64C160.9 64 32 192.9 32 352l0 80c0 8.8-7.2 16-16 16S0 440.8 0 432l0-80C0 175.3 143.3 32 320 32S640 175.3 640 352l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80C608 192.9 479.1 64 320 64zm-4 112c-95 0-172 77-172 172l0 84c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-84c0-112.7 91.3-204 204-204s204 91.3 204 204l0 84c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-84c0-95-77-172-172-172zM256 352l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-53 43-96 96-96s96 43 96 96l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-35.3-28.7-64-64-64s-64 28.7-64 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;